import { Box, Button, Typography } from "@mui/material";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { FC, useRef } from "react";
import {
  IModalComponentProps,
  EConfirmModalType,
  LoadingButton,
  ModalComponent,
} from "src/shared/components";
import { addressTitles } from "src/shared/constants/address.constants";
import { modalText } from "src/shared/constants/form.constants";
import { useConfirmModal } from "src/shared/hooks";
import { IAddressShort, TAddressType } from "src/shared/types/address.types";
import { usePostAddressMutation } from "../../model/api/partners";
import { addressDefaultValue } from "../../model/constants";
import { getPostAddressDto } from "../../model/helpers/helpers";
import { AddressForm } from "./AddressForm";

interface IAddAddressModalProps extends IModalComponentProps {
  partnerId: string;
  type: TAddressType;
  registrationCountryId: number;
}
export const AddAddressModal: FC<IAddAddressModalProps> = ({
  partnerId,
  type,
  registrationCountryId,
  ...modalCompnentProps
}) => {
  const formRef = useRef<HTMLFormElement>(null);
  const [postAddress, { isLoading }] = usePostAddressMutation();
  const handleSave = async (values: IAddressShort) => {
    const { isPostAddressTheSame, ...address } = values;
    try {
      await postAddress({
        partnerId,
        address: getPostAddressDto({
          ...address,
          country_id: address.country_id || registrationCountryId,
          type,
        }),
      }).unwrap();
      if (type === "legal" && isPostAddressTheSame) {
        await postAddress({
          partnerId,
          address: getPostAddressDto({ ...address, type: "postal" }),
        }).unwrap();
      }
      modalCompnentProps.onClose();
    } catch (e) {
      enqueueSnackbar("Произошла ошибка", {
        variant: "error",
        handleClose: closeSnackbar,
      });
      console.log(e);
    }
  };
  const { modal, showModal } = useConfirmModal({
    onResolve: modalCompnentProps.onClose,
    confirmModalType: EConfirmModalType.WARNING,
    confirmBtnProps: { isLoading: false, title: modalText.continue },
    children: <Typography>{modalText.unsavedChanges}</Typography>,
    title: modalText.confirmAction,
  });

  return (
    <>
      {modal}
      <ModalComponent
        {...modalCompnentProps}
        onClose={showModal}
        width={450}
        disableBodyPadding
        title={addressTitles[type]}
        modalFooter={
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <Button variant="outlined" onClick={showModal}>
              Отменить
            </Button>
            <LoadingButton
              isLoading={isLoading}
              variant="contained"
              onClick={() => {
                formRef.current?.submit();
              }}
            >
              Сохранить
            </LoadingButton>
          </Box>
        }
      >
        <AddressForm
          address={{ ...addressDefaultValue, type }}
          ref={formRef}
          handleSave={handleSave}
          registrationCountryId={registrationCountryId}
        />
      </ModalComponent>
    </>
  );
};
